import * as React from 'react';
import AddAoiForm from 'components/Layout/Form/AddAoiForm';
import * as AOIModule from 'Modules/AOIModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {createCoordsXYZ} from 'components/Map/CarDetails/Composites/_CompositesHelpers';
import {connect} from 'react-redux';
import {Polygon, Popup} from 'react-leaflet';

type AddZoneP = {};
type AddZoneS = {
    popupVisible: boolean;
    currentAddress: string;
};
type DispatchedP = {
    addNewAoi: Function;
    hideAddingAOIandWipeCoords: Function;
};
type ConnectedP = {
    aoiStore: AOIModule.Types.AOIStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

class AddZone extends React.Component<AddZoneP & DispatchedP & ConnectedP, AddZoneS> {
    constructor(props: AddZoneP & DispatchedP & ConnectedP) {
        super(props);
        this.state = {
            popupVisible: true,
            currentAddress: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    private handleSubmit(formData: any) {
        const coords = createCoordsXYZ(this.props.aoiStore.newZoneLatLng);
        let aoiDetails: AOIModule.Types.AddAreaOfInterestRequest;
        aoiDetails = formData;
        aoiDetails.coordinates = [coords];
        this.props.addNewAoi(aoiDetails);
    }

    public render() {
        const {aoiStore, hideAddingAOIandWipeCoords, viewManagementStore} = this.props;
        const {newZoneLatLng} = aoiStore;
        let popupPosition;
        if (newZoneLatLng.length > 0 && this.state.currentAddress === '') {
            popupPosition = {lat: newZoneLatLng[0][0], lng: newZoneLatLng[0][1]};
        }

        if (viewManagementStore.activeAddingAOI) {
            return newZoneLatLng.length > 0 && (
                <>
                    <Popup className="poidetails__wrapper" autoclose={false} closeOnClick={false}
                           position={popupPosition}>
                        <AddAoiForm
                            initialValues={{address: this.state.currentAddress}}
                            {...{
                                onClose: () => hideAddingAOIandWipeCoords(),
                                isPositionsCountIncorrect: newZoneLatLng.length < 3
                            }}
                            onSubmit={this.handleSubmit}
                        />
                    </Popup>
                    <Polygon className="zone" positions={[[newZoneLatLng]]}
                             onClick={() => this.setState({popupVisible: true})}/>
                </>
            )
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        aoiStore: state.aoiStore,
        viewManagementStore: state.viewManagementStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        addNewAoi: (aoiDetails: AOIModule.Types.AddAreaOfInterestRequest) => dispatch(AOIModule.Actions.addAoi(aoiDetails)),
        hideAddingAOIandWipeCoords: () => dispatch(ViewManagementModule.Actions.hideAddingAOIandWipeCoords())
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(AddZone);



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/AddZone.tsx